import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets';

@Component({
  selector: 'app-native-builds-cli-section',
  imports: [SectionHeaderComponent],
  templateUrl: './native-builds-cli-section.component.html',
  styleUrl: './native-builds-cli-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NativeBuildsCliSectionComponent {
  protected readonly terminalOutput = [
    {
      type: 'command',
      text: '$ npx @capawesome/cli apps:builds:create --app-id e063e283-24d8-4cff-bf08-ac551890bd71 --git-ref main --platform=android --apk myapp.apk',
    },
    { type: 'info', text: 'Building web assets...' },
    { type: 'info', text: 'Running build command: npm run build' },
    { type: 'output', text: '> build' },
    { type: 'output', text: '> vite build' },
    { type: 'output', text: 'vite v5.4.11 building for production...' },
    { type: 'output', text: '✓ 1247 modules transformed.' },
    { type: 'success', text: 'Web assets built successfully.' },
    { type: 'info', text: 'Syncing Android platform...' },
    { type: 'info', text: 'Loading environment variables (12 found)' },
    { type: 'info', text: 'Loading environment secrets (3 found)' },
    { type: 'success', text: 'Platform synced successfully.' },
    { type: 'info', text: 'Configuring Gradle build...' },
    { type: 'info', text: 'Building Android app...' },
    { type: 'info', text: 'Running Gradle task: assembleRelease' },
    { type: 'output', text: '> Task :app:preBuild' },
    { type: 'output', text: '> Task :app:mergeReleaseResources' },
    { type: 'output', text: '> Task :app:compileReleaseKotlin' },
    { type: 'info', text: 'Applying ProGuard configuration...' },
    { type: 'output', text: '> Task :app:minifyReleaseWithR8' },
    { type: 'output', text: '> Task :app:packageRelease' },
    { type: 'success', text: 'Android app built successfully.' },
    { type: 'info', text: 'Build artifact: app-release.aab (24.3 MB)' },
    { type: 'info', text: 'Uploading build artifact to Capawesome Cloud...' },
    { type: 'success', text: 'Build artifact uploaded successfully.' },
    { type: 'success', text: 'Build completed in 2m 32s.' },
    { type: 'info', text: 'Downloading build artifact...' },
    { type: 'success', text: 'Build artifact downloaded: myapp.apk' },
  ];
}
